export const STATUS_MAP = {
    CONFIRMED: 'Order placed',
    PARTIALLY_IN_PRODUCTION: 'Partially in production',
    IN_PRODUCTION: 'In production',
    PARTIALLY_SHIPPED: 'Partially shipped',
    SHIPPED: 'Shipped',
    PARTIALLY_DELIVERED: 'Partially delivered',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    CANCELLED: 'Canceled',
};
export const SALES_CHANNEL_MAP = {
    OnlineStore: 'Fourthwall shop',
    TikTok: 'TikTok shop',
    Meta: 'Meta shop',
};
export const ORDER_TYPE_MAP = {
    CREATOR_BUDGET: 'Only sample orders',
};
